export const WaldayuInfo = Object.freeze({
    allEntries: window['getAllEntries'](),
    allAudioEntries: window['getAllAudioEntries'](),
    config: window['config'],
    dataDict: window['dataDict'],
    dataKeys: Object.keys(window['dataDict']),
    songs: window['songs']

    //... more of your variables
});






// WEBPACK FOOTER //
// ./src/app/global.ts